// The Fifth House — vanilla theme JS
(function(){
  // Persistent hero parallax — moves the fixed background slowly with scroll
  function initHeroParallax(){
    var bg = document.querySelector('.hero-bg-fixed img');
    if(!bg) return;
    var frame = 0;
    function update(){
      var y = window.scrollY * 0.18;
      bg.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.12)';
    }
    function onScroll(){
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }
    update();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
  }

  // Inner parallax (feature/story images)
  function initInnerParallax(){
    var els = document.querySelectorAll('[data-parallax]');
    if(!els.length) return;
    var frame = 0;
    function update(){
      var vh = window.innerHeight;
      els.forEach(function(el){
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        var rect = el.getBoundingClientRect();
        if(rect.bottom < -200 || rect.top > vh + 200) return;
        var center = rect.top + rect.height/2 - vh/2;
        var offset = -center * speed;
        el.style.transform = 'translate3d(0,' + offset + 'px,0)';
      });
    }
    function onScroll(){ cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }
    update();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
  }

  // Reveal-on-scroll
  function initReveal(){
    var els = document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    els.forEach(function(el){ io.observe(el); });
  }

  // Sticky header glass on scroll
  function initHeader(){
    var h = document.querySelector('.tfh-header');
    if(!h) return;
    function onScroll(){
      if(window.scrollY > 40) h.classList.add('is-scrolled');
      else h.classList.remove('is-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  // Menu drawer
  function initDrawer(){
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = document.querySelectorAll('[data-drawer-close]');
    var drawer = document.querySelector('.tfh-drawer');
    if(!drawer) return;
    openers.forEach(function(b){ b.addEventListener('click', function(){ drawer.classList.add('is-open'); }); });
    closers.forEach(function(b){ b.addEventListener('click', function(){ drawer.classList.remove('is-open'); }); });
  }

  // Product variant picker
  function initProduct(){
    var form = document.querySelector('[data-product-form]');
    if(!form) return;
    var variantData = window.__tfhVariants || [];
    var priceEl = document.querySelector('[data-product-price]');
    var idInput = form.querySelector('[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    var selects = form.querySelectorAll('[data-option-index]');

    function findVariant(){
      var chosen = Array.from(selects).map(function(s){ return s.value; });
      return variantData.find(function(v){
        return v.options.every(function(o,i){ return o === chosen[i]; });
      });
    }
    function update(){
      var v = findVariant();
      if(!v){ submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if(priceEl) priceEl.textContent = v.price;
      submitBtn.disabled = !v.available;
      submitBtn.textContent = v.available ? 'Add To Bag' : 'Sold Out';
    }
    selects.forEach(function(s){ s.addEventListener('change', update); });
    update();

    // Thumbnail switch
    var thumbs = document.querySelectorAll('[data-thumb]');
    var main = document.querySelector('[data-main-image]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        if(main) main.src = t.dataset.thumb;
        thumbs.forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initHeroParallax();
    initInnerParallax();
    initReveal();
    initHeader();
    initDrawer();
    initProduct();
  });
})();
